class DeviceWidth {
  constructor() {
    this.isDesktop = window.innerWidth > 1024;
  }
}

const getScrollbarWidth = () => {
  const rootElement = document.documentElement;
  const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;

  rootElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
  if (scrollbarWidth === 0) {
    document.body.classList.add('no-scrollbar');
  }
};

class DateUtils {
  constructor() {}

  getTimeObjFromMS(ms) {
    return {
      days: String(Math.floor(ms / (1000 * 60 * 60 * 24))).padStart(2, '0'),
      hours: String(Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
      minutes: String(Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
      seconds: String(Math.floor((ms % (1000 * 60)) / 1000)).padStart(2, '0'),
    };
  }

  getTimeString(timeObj) {
    return (
      Object.keys(timeObj)
        .map((unit) => (timeObj[unit] !== '00' ? `${timeObj[unit]}${unit[0]}` : ''))
        .filter(Boolean)
        .join(':') + (timeObj.seconds === '00' ? `:${timeObj.seconds}s` : '')
    );
  }

  getCurrentUTCDate() {
    const now = new Date();
    return new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
  }

  formatDate(date) {
    const dateComponents = date.split(/[\-T:]/);
    const day = parseInt(dateComponents[2]);
    const month = parseInt(dateComponents[1]) - 1; // Month is 0-indexed in JavaScript
    const year = parseInt(dateComponents[0]);
    const hour = parseInt(dateComponents[3]);
    const minute = parseInt(dateComponents[4]);
    const second = parseInt(dateComponents[5]?.split('.')?.[0]) || 0;

    return new Date(year, month, day, hour, minute, second);
  }
}

getScrollbarWidth();

function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

class WishlistCartVariantRadios {
  constructor(element) {
    this.selectors = {
      variantButton: '.button-variant',
      variantId: '.product-variant-id',
      updateButton: '.select-size',
    };
    this.element = element;
    this.variantBtn = this.element.querySelectorAll(this.selectors.variantButton);
    this.variantBtn.forEach((button) => button.addEventListener('click', () => this.showUpdateBtn(button))); 
  }

  showUpdateBtn(clickedButton) {
    const allButtonVariants = this.element.querySelectorAll(this.selectors.variantButton);
    allButtonVariants.forEach((button) => button.classList.add('button--secondary')); 

    this.element.querySelector('.select-size').classList.remove('button--secondary'); 

    const selectSizeElements = this.element.querySelectorAll(this.selectors.updateButton);
    selectSizeElements.forEach((el) => { 
      const updateSizeSpan = document.createElement('span'); 
      const buttonVariantSpan = document.createElement('span'); 

      updateSizeSpan.innerText = 'Update Size '; 
      buttonVariantSpan.innerText = `${clickedButton.getAttribute('data-size-scale')}  ${clickedButton.getAttribute('data-text')}`; 
      el.innerHTML = ''; 
      el.appendChild(updateSizeSpan);
      el.appendChild(buttonVariantSpan); 
    });

    this.element.querySelectorAll(this.selectors.variantId).forEach((input) => (input.value = clickedButton.value)); 
    clickedButton.classList.remove('button--secondary'); 
  }
}

function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));  // Calcola la data di scadenza
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toUTCString(); 
}

function deleteCookie(name) {
  setCookie(name, '', -1);  // Imposta la data di scadenza al passato per rimuovere il cookie
}


function closeModal(modal) {
  scrollLock.enablePageScroll();
  // document.body.classList.remove('overflow-hidden', 'modal-open');
  document.querySelector(modal).classList.remove('visible');
}

function openModal(modal) {
  scrollLock.disablePageScroll();
  //document.body.classList.add('overflow-hidden', 'modal-open');
  document.querySelector(modal).classList.add('visible');

  document.addEventListener('click', function (event) {
    if (event.target === document.querySelector(modal)) {
      closeModal(modal);
    }
  });
}

//identifica se è crawel di google
function UserCrawelGoogle() {
  const botPattern = '(googlebot/|Googlebot-Image)';
  const re = new RegExp(botPattern, 'i');
  return re.test(navigator.userAgent);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!elements?.length) return;
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    const accessibilityLink =  this.querySelector('[data-accessibility]');
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.utilityLinks = this.querySelector('.menu-drawer__utility-links.bottom')
    this.header = this.querySelector('.menu-drawer__navigation--tabs-menu')

    subscribe(PUB_SUB_EVENTS.openMenu, () => {
      setTimeout(() => {
        this.addBlur()
      }, 500)
    })
    subscribe(PUB_SUB_EVENTS.menuChange, () => {
      this.addBlur()
    })

    accessibilityLink.addEventListener('click', () => {
      this.mainDetailsToggle.querySelector('summary')?.click();
      document.querySelector('footer .accessibility-app')?.click()
    })
  }


  addBlur() {
    const links = this.querySelector('.menu-drawer__navigation--childlinks-menu.open');
    function isOverflown(el) {
      if (!el?.style) return
      const curOverflow = el.style.overflow;
      if ( !curOverflow || curOverflow === "visible" ) {
        el.style.overflow = "hidden";
      }
      const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
      el.style.overflow = curOverflow;
      return isOverflowing;
    }

    this.header.classList.remove('overlay')

    if (isOverflown(links)) {
      this.utilityLinks.classList.add('overlay')
    } else {
      this.utilityLinks.classList.remove('overlay')
    }

    links?.addEventListener('scroll', () => {

      if (links.scrollTop === 0) {
        this.header?.classList.remove('overlay')
      } else {
        this.header?.classList.add('overlay')
      }
      if( links.scrollTop === (links.scrollHeight - links.offsetHeight)) {
        this.utilityLinks.classList.remove('overlay')
      } else {
        this.utilityLinks.classList.add('overlay')
      }
    })
  }

  bindEvents() {
    this.querySelectorAll('summary')
      .forEach((summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('.menu-drawer__close-button')
      .forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const allTabs = document.querySelectorAll('.menu-drawer__navigation ul > details');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    // rimuovo la classe open a tutte le tab
    if (summaryElement.parentNode.classList.contains('tabs-menu')) {
      for (let i = 0; i < allTabs.length; i++) {
        allTabs[i].removeAttribute('open');
      }
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      let animationTime = 0;
      setTimeout(() => {
        document.body.setAttribute('menu-child-open', true);
        //detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, animationTime);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-mobile`);
  }

  closeMenuDrawer(event, elementToFocus = false) {

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      // details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-mobile`);

    //document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event === undefined) return;

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details[open]');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    //detailsElement.removeAttribute('open')
    const parentMenuElement = detailsElement.closest('.submenu-open');
    document.body.removeAttribute('menu-child-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    // detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    //original value: 400
    let disableTime = 0;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < disableTime) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class Megamenu extends HTMLElement {
  constructor() {
    super();
    const deviceWidth = new DeviceWidth();
    this.isDesktop = deviceWidth.isDesktop;
    this.parentVoices = document.querySelectorAll(
      '.megamenu .parent-voices li, .menu-drawer__navigation--tabs-menu li, .open-helpdesk'
    );
    this.childVoices = document.querySelectorAll('.megamenu .childlinks, .menu-drawer__navigation--childlinks-menu');
    this.subchildVoices = document.querySelectorAll('.megamenu .childlinks .childlink-voice');

    /* [AV]: megamenu voice with no childlinks */
    this.nochildVoice = this.querySelectorAll('.megamenu .childlinks .childlink-nolink.is-collection'); //only if is a collection

    this.header = document.querySelector('.megamenu');

    this.init();
    this.loadCollectionsData()
  }

  async loadCollectionsData() {

    const response = await fetch(`${location.origin + window.routes.route_url || ''}/pages/menu-json?menu=${this.dataset.menu}`);
    
    const responseText = await  response.text()
    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

    const arrayMenu = [];
    responseHTML
          .querySelector('#menu-json')
          .innerText
          .split('___')
          .forEach(el => {
            try {
              arrayMenu.push(JSON.parse(el));
            } catch (e) {
              console.log("error", e)
            }
          })

    const megaMenuLinks =  Array.from( document.querySelectorAll('mega-menu a.link'))
    const menuDrawerLinks = Array.from(document.querySelectorAll('#menu-drawer a.link'))
    const concatenatedArray = megaMenuLinks.concat(menuDrawerLinks);

    concatenatedArray
      .forEach(link => {
        const htmlLink = arrayMenu.find(jsonLink => jsonLink.url === link.getAttribute('href') )
        if (!htmlLink)  return
        const counter = link.querySelector('.counter--span')
        const image = link.querySelector('[data-icon]')
        if (image && htmlLink.image) {
          const newImage = document.createElement('img');
          newImage.src = htmlLink.image;
          newImage.height = 38
          newImage.setAttribute('loading', 'lazy')
          newImage.width = 28
          image.appendChild( newImage)
        }
         if (counter && htmlLink.productCount > 0) {
           counter.innerText =`( ${htmlLink.productCount} )`
         }
      })
  }

  init() {
    this.parentVoices.forEach((voice) => voice.addEventListener('click', () => this.openRelativeSubmenu(voice)));
    this.hoverSubChildMegaMenuVoices();
    this.setActiveVoiceOnDocReady();
    this.hoverCollectionNoChild();
  }

  setActiveVoiceOnDocReady() {
    if (this.isTemplateAccount() && this.isDesktop) return;
    const activeMenuVoice = getCookie('menuVoiceActive') || 'men';

    this.parentVoices.forEach((parentVoice) =>
      parentVoice.classList.toggle('active', parentVoice.getAttribute('data-menu') === activeMenuVoice)
    );

    this.childVoices.forEach((childVoice) =>
      childVoice.classList.toggle('open', childVoice.getAttribute('data-relative-menu') === activeMenuVoice)
    );
  }

  // Function to open the mega menu and apply associated styles
  megamenuVoiceOpen(targetItem) {
    // Update header attributes
    this.updateHeaderAttributes(true);
    targetItem.classList.add('visible');
    document.body.classList.add('lock-scroll');

    // Check if the header icon is not "sticky" and apply blur effect to the footer
    if (!document.querySelector('header-icons').classList.contains('sticky')) {
      document.getElementsByClassName('footer-wrapper')[0].classList.add('blur-overlay');
    }
  }

  // Function to close the mega menu and reset styles
  megamenuVoiceClose(targetItem) {
    // Reset header attributes
    this.updateHeaderAttributes(false);
    targetItem.classList.remove('visible');
    document.body.classList.remove('lock-scroll');

    // Check if the header icon is not "sticky" and remove blur effect from the footer
    if (!document.querySelector('header-icons').classList.contains('sticky')) {
      document.getElementsByClassName('footer-wrapper')[0].classList.remove('blur-overlay');
    }
  }

  updateHeaderAttributes(isBorder) {
    document.querySelector('.header__icons').setAttribute('border', isBorder);
  }

  openRelativeSubmenu(voice) {
    this.parentVoices
      .forEach(
        (parentVoice) => parentVoice.classList.remove('active')
      );

    this.childVoices.forEach((childVoice) => {
      const isMatchingMenu = childVoice.getAttribute('data-relative-menu') === voice.dataset.menu;
      if (isMatchingMenu) {
        const isOpen = this.hasToToggleMenu(voice) && childVoice.classList.contains('open');
        // if helpdesk voice is toggle becase he need to back to main voices tab
        voice.classList.toggle('active', !isOpen);
        childVoice.classList.toggle('open', !isOpen);
        this.header.classList.toggle('active', !isOpen);

        const isHelpdesk = voice.getAttribute('data-menu') === 'helpdesk' && !childVoice.classList.contains('open');

        if (isHelpdesk) {
          const activeMenuVoice = getCookie('menuVoiceActive');
          document
            .querySelectorAll(`[data-menu="${activeMenuVoice}"]`)
            .forEach((parent) => parent.classList.add('active'));
          document
            .querySelectorAll(`[data-relative-menu="${activeMenuVoice}"]`)
            .forEach((child) => child.classList.add('open'));
        }
      } else {
        childVoice.classList.remove('open');
        this.header.classList.remove('active');
      }
    });
    publish(PUB_SUB_EVENTS.menuChange)
    this.handleViewAccount();
    this.updateMenuVoiceActive(voice.innerText.toLowerCase());
  }

  hasToToggleMenu(voice) {
    const isHelpdesk = voice.getAttribute('data-menu') === 'helpdesk';
    if (this.isDesktop) {
      return isHelpdesk || this.isTemplateAccount();
    }
    return isHelpdesk;
  }

  isTemplateAccount() {
    /*[ALS]: understand why in PROD orders has no suffix orders (need to check for path) */
    const template = SlamJam.settings.template;
    const suffix = SlamJam.settings.templateSuffix;
    const path = window.location.pathname;

    return (
      suffix === 'stores' ||
      template === '404' ||
      template === 'account' ||
      template === 'addresses' ||
      template === 'blog' ||
      template === 'article' ||
      suffix === 'wishlist' ||
      suffix === 'orders' ||
      path.includes('pages/orders') ||
      path.includes('apps/return-and-exchanges') ||
      path.includes('apps/check-order-status/')
    );
  }

  handleViewAccount() {
    const openLinks = document.querySelectorAll('.childlinks.open')?.length || 0;
    const accountLinks = document.querySelector('.account-links');
    if (accountLinks) {
      accountLinks.classList.toggle('hide', openLinks > 0);
    }
  }

  updateMenuVoiceActive(menuVoice) {
    if (menuVoice !== 'help') {
      setCookie('menuVoiceActive',  menuVoice);
    }
  }

  hoverSubChildMegaMenuVoices() {
    new SV.HoverIntent(this.subchildVoices, {
      onEnter: (targetItem) => this.megamenuVoiceOpen(targetItem),
      onExit: (targetItem) => this.megamenuVoiceClose(targetItem),
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    });
  }

  hoverCollectionNoChild() {
    new SV.HoverIntent(this.nochildVoice, {
      onEnter: (targetItem) => this.megamenuVoiceOpen(targetItem),
      onExit: (targetItem) => this.megamenuVoiceClose(targetItem),
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    });
  }
}

customElements.define('mega-menu', Megamenu);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.elementsToScroll = document.querySelectorAll(
      '.menu-drawer__navigation--childlinks-menu, .menu-drawer__menu-item--grandchild, #search-bar-results .grand-child--bottom'
    );
  }

  connectedCallback() {
    document.querySelector('[data-trigger-menu]').addEventListener('click', () => {
      this.mainDetailsToggle.querySelector('summary').click();
    });
  }

  openMenuDrawer(summaryElement) {
    publish(PUB_SUB_EVENTS.openMenu);

    this.header = this.header || document.querySelector('.header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    const headerBottom = parseInt(window.innerHeight - this.header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(headerBottom + this.header.getBoundingClientRect().height - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.elementsToScroll.forEach((element) => {
        scrollLock.disablePageScroll(element);
      });

      document.querySelector('body').classList.add('menu-open');
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    // document.body.classList.add('overflow-hidden-mobile','overflow-hidden-tablet');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    document.querySelector('body').classList.remove('menu-open');
    //document.body.classList.remove('overflow-hidden-mobile','overflow-hidden-tablet');
    super.closeMenuDrawer(event, elementToFocus);
    // this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    publish(PUB_SUB_EVENTS.closeMenu);

    this.elementsToScroll.forEach((element) => {
      scrollLock.enablePageScroll(element);
    });
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class HeaderIconsWrapper extends HTMLElement {
  constructor() {
    super();

    this.bindEvents();
  }

  static get observedAttributes() {
    return ['border'];
  }

  bindEvents() {
    const self = this;

    document.addEventListener('DOMContentLoaded', function () {
      self.updatePosition();
    });

    window.addEventListener('scroll', function () {
      self.updatePosition();
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'border') {
      if (newValue == 'true') {
        this.classList.add('no-border');
      } else {
        this.classList.remove('no-border');
      }
    }
  }

  updatePosition() {
    this.scrollpos = window.scrollY;
    const templatesClasses = [
      'template-collection',
      'template-product',
      'template-register',
      'template-addresses',
      'template-login',
      'template-account',
      'template-page',
      'template-order-status',
    ];
    const containsClass = Array.from(document.body.classList).filter((el) => templatesClasses.includes(el));

    const footerH = document.querySelector('.footer__last-content').offsetHeight;
    const scrollableHeight = document.documentElement.scrollHeight - (window.innerHeight + footerH);

    if (!document.body.classList.contains('template-cart')) {
      /* Sticy header icons */
      this.scrollpos >= scrollableHeight
        ? this.classList.remove('sticky', 'header__icons--localization')
        : this.classList.add('sticky', 'header__icons--localization');
    }
    if (containsClass.length > 0) {
      /* Sticy header change border */
      this.scrollpos > 0 && this.scrollpos < scrollableHeight
        ? this.classList.add('scroll')
        : this.classList.remove('scroll');
    }
  }
}

customElements.define('header-icons', HeaderIconsWrapper);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.scrollY = window.scrollY;
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    // window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.scrollTo(window.scrollX, this.scrollY);
    // window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      // Determine the vertical position of the click relative to the element's bounding rectangle
      const rect = this.getBoundingClientRect();
      const topOffset = event.clientY - rect.top;
      const bottomOffset = rect.bottom - event.clientY;
      const height = rect.height;

      // Calculate thresholds for top, center, and bottom
      const topThreshold = height * 0.3; // Adjust as needed
      const bottomThreshold = height * 0.3; // Adjust as needed

      const button = this.querySelector('button');
      if (!button) return;
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
      const mediaId = button.getAttribute('data-media-id');
      const currentMedia = modal.querySelector(`#product-media-${mediaId}`);
      if (topOffset < topThreshold) {
        currentMedia.scrollIntoView({ behavior: 'instant', block: 'start' });
      } else if (bottomOffset < bottomThreshold) {
        currentMedia.scrollIntoView({ behavior: 'instant', block: 'end' });
      } else {
        currentMedia.scrollIntoView({ behavior: 'instant', block: 'center' });
      }
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    this.autoplay = this.getAttribute('autoplay') == 'true';
    if (this.autoplay) {
      this.querySelector('button')?.click();
    }
  }

  loadContent() {
    window.pauseAllMedia();

    if (this.getAttribute('loaded')) return;
    const content = document.createElement('div');
    content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

    this.setAttribute('loaded', true);
    const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
    if (deferredElement.nodeName == 'VIDEO' ) {
      // force autoplay for safari
      deferredElement.play();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class SplideSliderComponent extends HTMLElement {
  static observedAttributes = ['restart'];

  constructor() {
    super();
    this.hasMounted = false;
    const self = this;

    if (!self.dataset.autoscroll) {
      document.addEventListener('DOMContentLoaded', function () {
        self.initSlider();
      });
    }

    window.addEventListener('splide-refresh', function () {
      self.initSlider();
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'restart') this.initSlider(true);
  }

  // [ALS]: The intersection observer has been added to diminish js execution time on load. To fix in case of problems
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.initSlider();
    };
    if (this.dataset.autoscroll) {
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }

  initSlider(restart = false) {
    if (this.hasMounted && !restart) return;
    this.splide = new Splide(this);
    this.autoscroll = this.dataset.autoscroll ? window.splide.Extensions : '';
    this.isGallery = this.dataset.type === 'gallery';

    this.startSlider();
    this.hasMounted = true;
  }

  startSlider() {
    this.splide.mount(this.autoscroll);
    if (this.isGallery) {
      this.startGallery();
    }
  }

  startGallery() {
    const self = this;

    const thumbnailsStores = document.querySelectorAll('.thumbnails-store-' + this.id);
    let current;

    Array.from(thumbnailsStores).forEach((thumbnailStore) => {
      const thumbnails = Array.from(thumbnailStore.querySelectorAll('.thumbnail-store'));
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', function () {
          self.splide.go(index);
        });
      });
    });

    self.splide.on('move', function () {
      var thumbnail = thumbnails[splide.index];
      if (thumbnail) {
        if (current) {
          current.classList.remove('is-active');
        }
        thumbnail.classList.add('is-active');
        current = thumbnail;
      }
    });
  }
}

customElements.define('splide-slider', SplideSliderComponent);


class ShippingMessageDinamic {
  constructor() {
    this.shippingCountriesSelect = document.querySelectorAll('.banner-shipping__countries'); //update primary markets each country selects of website
    this.divDetailsContainer = document.querySelectorAll('.shipping-message');
    this.init();
  }

  checkIfOptionExist(select) {
    const validOptions = Array.from(select.options).filter((option) => {
      if (option.classList.contains('separator')) {
        return true;
      }

      const selectedValue = option.value;
      const country = SlamJam.settings.popupRedirect.availableCountries.find(
        (country) => selectedValue === country.isocode
      );

      const isocodeMatch = ShippingMessages.available_info.some((shippingMessage) => {
        return shippingMessage.isocode.split(';').some((code) => {
          return country && country.isocode === code;
        });
      });

      return (
        isocodeMatch ||
        (country &&
          ShippingMessages.available_info.some((shippingMessage) => shippingMessage.isocode === country.market_handle))
      );
    });

    select.innerHTML = '';
    validOptions.forEach((optionData) => {
      select.appendChild(optionData);
    });
  }

  appendMessageInAccordion(selectedCountry) {
    // Find the ISO code of the selected country among the available ones
    const currentCountryIsoCode = SlamJam.settings.popupRedirect.availableCountries.find(
      (country) => country.isocode === selectedCountry
    )?.isocode;
    // Variable to store the country description to append
    let descriptionCountryToAppend = '';

    // Iterate through the available shipping messages
    ShippingMessages.available_info.forEach((countryInfo) => {
      // Split the country ISO code to check if it matches the selected country
      const countryCodes = countryInfo.isocode.split(';');
      countryCodes.forEach((code) => {
        if (code === currentCountryIsoCode) {
          // If the code matches, set the description of the country to append
          descriptionCountryToAppend = countryInfo.description || '';
        }
      });
    });

    // Update detail containers with the country description (empty if not found)
    this.divDetailsContainer.forEach((container) => {
      container.innerHTML = descriptionCountryToAppend;
    });

    // Add the 'visible' class to elements with the 'ship-and-return' class if there is a country description
    if (descriptionCountryToAppend) {
      document.querySelectorAll('.ship-and-return').forEach((element) => {
        element.classList.add('visible');
      });
    }
  }

  init() {
    const self = this;
    const countryToCheck = getCookie('forceLocalization') || Shopify.country;

    self.shippingCountriesSelect.forEach((select) => {
      self.checkIfOptionExist(select, countryToCheck);
      self.changeCountryShipMessage(select);
    });

    self.appendMessageInAccordion(countryToCheck);
  }

  changeCountryShipMessage(select) {
    select.addEventListener('change', () => {
      const selectValue = select.value;
      this.appendMessageInAccordion(selectValue);
    });
  }
}

if (SlamJam.settings.template == 'product' && document.querySelector('.ship-and-return')) {
  new ShippingMessageDinamic();
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class CrossTable extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    const rows = this.querySelectorAll("tr");
    rows.forEach((row, rowIndex) => {
      const cells = row.querySelectorAll("td");
      cells.forEach((cell, colIndex) => {
        cell.addEventListener("mouseenter", () => {
          this.clearHighlights();
          this.highlightRow(rowIndex);
          this.highlightColumn(colIndex);
        });

        cell.addEventListener("mouseleave", () => {
          this.clearHighlights();
        });

      });
    });
  }

  highlightRow(rowIndex) {
    const row = this.querySelectorAll("tr")[rowIndex];
    row.querySelectorAll("td").forEach(cell => cell.classList.add("cell-hover"));
  }

  highlightColumn(colIndex) {
    const rows = this.querySelectorAll("tr");
    rows.forEach(row => {
      const cells = row.querySelectorAll("td");
      if (cells[colIndex]) cells[colIndex].classList.add("cell-hover");
    });
  }

  clearHighlights() {
    this.querySelectorAll("td.cell-hover").forEach(cell => {
      cell.classList.remove("cell-hover");
    });
  }

}

customElements.define('cross-table', CrossTable);
